module.exports = __webpack_public_path__ + "static/media/home.36070273.svg";